import React, { useRef, useEffect, useContext } from "react";
import Slider from "react-slick";
import { AppContext } from "../App";
import { MdArrowForward, MdLogin } from "react-icons/md";

// Uwekezaji wa mabango yote saba ya mfumo
import banner1 from "../assets/banner1.png";
import banner2 from "../assets/banner2.png";
import banner3 from "../assets/banner3.png";
import banner4 from "../assets/banner4.png";
import banner5 from "../assets/banner5.png";
import banner6 from "../assets/banner6.png";
import banner7 from "../assets/banner7.png";
import banner8 from "../assets/banner8.png";
import banner9 from "../assets/banner9.png";

export default function HomeSlider() {
  const sliderRef = useRef(null);
  const appContext = useContext(AppContext);

  // Safu ya data ya mabango 7 ikiwa na ujumbe thabiti wa lugha ya Kiswahili
  const slideContents = [
    {
      image: banner1,
      tagline: "KARIBU YCSC SACCOS",
      title: "Mshikamano Daima",
      subtitle:
        "Kukuza na kuwawezesha wanachama wetu kiuchumi kupitia utamaduni wa kuweka akiba na fursa endelevu za maendeleo.",
      primaryBtn: "Huduma Zetu",
      primaryAction: "services",
      secondaryBtn: "Mfumo wa Wanachama",
      secondaryAction: "portal",
    },
    {
      image: banner2,
      tagline: "UKUAJI WA KIFEDHA",
      title: "Utamaduni wa Akiba Smart",
      subtitle:
        "Tunatengeneza mazingira salama na yenye tija ya uwekezaji wa amana ili kuhakikisha unajenga mtaji imara wa muda mrefu.",
      primaryBtn: "Angalia Miradi",
      primaryAction: "services",
      secondaryBtn: "Jiunge Nasi",
      secondaryAction: "registration",
    },
    {
      image: banner3,
      tagline: "SULUHISHO LA MIKOPO",
      title: "Mikopo Nafuu ya Maendeleo",
      subtitle:
        "Nufaika na mikopo yenye riba nafuu iliyoundwa mahususi kuendeleza taaluma, biashara na malengo yako ya ujasiriamali.",
      primaryBtn: "Bidhaa za Mikopo",
      primaryAction: "services",
      secondaryBtn: "Jifunze Zaidi",
      secondaryAction: "about_us",
    },
    {
      image: banner4,
      tagline: "HUDUMA ZA KIDIJITALI",
      title: "Mfumo Rahisi wa Amala Portal",
      subtitle:
        "Fuatilia michango yako, kagua salio kwa wakati halisi, na uombe mikopo mahali popote kupitia mfumo wa kisasa wa Amala.",
      primaryBtn: "Ingia Kwenye Mfumo",
      primaryAction: "portal",
      secondaryBtn: "Usaidizi wa Kiufundi",
      secondaryAction: "contact_us",
    },
    {
      image: banner5,
      tagline: "JAMII NA UAMINIFU",
      title: "Kujenga Ustahimilivu wa Pamoja",
      subtitle:
        "Ushirika rasmi na imara unaokua kwa kasi ukijumuisha wataalamu waliojitolea nchi nzima nchini Tanzania.",
      primaryBtn: "Historia Yetu",
      primaryAction: "about_us",
      secondaryBtn: "Wasiliana Nasi",
      secondaryAction: "contact_us",
    },
    {
      image: banner6,
      tagline: "WEKEZA KWA KUJIAMINI",
      title: "Upanuzi wa Kimkakati wa Mitaji",
      subtitle:
        "Tunatumia uwekezaji wa pamoja wa rasilimali ili kuzalisha faida kubwa na kulinda kwa dhati ukwasi wa wanachama wetu.",
      primaryBtn: "Huduma Zetu",
      primaryAction: "services",
      secondaryBtn: "Soma Zaidi",
      secondaryAction: "about_us",
    },
    {
      image: banner7,
      tagline: "UTAWALA BORA NA IMARA",
      title: "Uongozi Wenye Uwajibikaji",
      subtitle:
        "Tunaongozwa na Bodi ya Wakurugenzi iliyochaguliwa kidemokrasia, yenye uwazi na inayozingatia maadili mema ya kifedha.",
      primaryBtn: "Kutana na Bodi",
      primaryAction: "leadership",
      secondaryBtn: "Sera Zetu",
      secondaryAction: "about_us",
    },
    {
      image: banner8,
      tagline: "UTAWALA NA UONGOZI BORA",
      title: "Timu Thabiti ya YCSC SACCOS",
      subtitle:
        "Kutana na viongozi na watumishi wako waliojitolea kusimamia mitaji yenu kwa uwazi, uadilifu na ufanisi mkubwa wa kidijitali.",
      primaryBtn: "Kuhusu Sisi",
      primaryAction: "about_us",
      secondaryBtn: "Wasiliana Nasi",
      secondaryAction: "contact_us",
    },
    {
      image: banner9,
      tagline: "NGUVU YA USHIRIKA WETU",
      title: "Jumuia Imara ya Wanachama",
      subtitle:
        "Sisi ni familia kubwa ya kiuchumi inayounganishwa na malengo ya pamoja, tukiwasaidia wanachama wetu wote nchini kote kufikia uhuru wa kweli wa kifedha.",
      primaryBtn: "Gundua Fursa Zetu",
      primaryAction: "services",
      secondaryBtn: "Ingia Kwenye Mfumo",
      secondaryAction: "portal",
    },
  ];

  useEffect(() => {
    const slider = sliderRef.current;
    const preventTouchEvents = (e) => {
      e.stopPropagation();
    };

    if (slider) {
      slider.addEventListener("touchstart", preventTouchEvents, {
        passive: true,
      });
      slider.addEventListener("touchmove", preventTouchEvents, {
        passive: true,
      });
      slider.addEventListener("touchend", preventTouchEvents, {
        passive: true,
      });
    }

    return () => {
      if (slider) {
        slider.removeEventListener("touchstart", preventTouchEvents);
        slider.removeEventListener("touchmove", preventTouchEvents);
        slider.removeEventListener("touchend", preventTouchEvents);
      }
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    fade: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    appendDots: (dots) => (
      <div className="slider-dots-container">
        <ul className="m-0 p-0"> {dots} </ul>
      </div>
    ),
    customPaging: () => <div className="custom-slider-dot"></div>,
  };

  const handleNavigation = (action) => {
    if (action === "portal") {
      window.open("https://ycs.amala.app/#/login", "_blank", "noreferrer");
    } else {
      appContext.navTo({ item: action });
    }
  };

  return (
    <div className="WelcomeSlider position-relative w-100" ref={sliderRef}>
      <Slider {...settings}>
        {slideContents.map((slide, index) => (
          <div key={index} className="slide-wrapper">
            <div
              className="hero-slide-bg"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="hero-overlay-dark d-flex align-items-center">
                <div className="container">
                  <div className="row">
                    <div className="col-12 col-md-10 col-lg-7 text-start content-animation-block">
                      {/* Lebo Ndogo ya Kauli Mbiu */}
                      <span className="badge-tagline text-uppercase d-inline-block mb-3">
                        {slide.tagline}
                      </span>

                      {/* Kichwa Kikuu cha Habari */}
                      <h1 className="hero-title fw-bold mb-3 text-white">
                        {slide.title}
                      </h1>

                      {/* Maelezo Mafupi */}
                      <p className="hero-description mb-4">{slide.subtitle}</p>

                      {/* Vifungo vya Vitendo */}
                      <div className="d-flex flex-wrap gap-3 align-items-center hero-action-row">
                        <button
                          className="btn btn-hero-primary d-flex align-items-center gap-2"
                          onClick={() => handleNavigation(slide.primaryAction)}
                        >
                          <span>{slide.primaryBtn}</span>
                          <MdArrowForward
                            className="hero-btn-arrow"
                            size={18}
                          />
                        </button>

                        <button
                          className="btn btn-hero-secondary d-flex align-items-center gap-2"
                          onClick={() =>
                            handleNavigation(slide.secondaryAction)
                          }
                        >
                          {slide.secondaryAction === "portal" && (
                            <MdLogin size={16} />
                          )}
                          <span>{slide.secondaryBtn}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
